import React, {
  useState,
  useMemo,
} from "react";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";

function HistoricalTrendChart({
  historicalProducts = [],
}) {

  // =====================================================
  // STATE
  // =====================================================

  const [selectedProduct,
    setSelectedProduct] =
    useState("");

  // =====================================================
  // SAFE ARRAY
  // =====================================================

  const safeProducts =
    Array.isArray(
      historicalProducts
    )
      ? historicalProducts
      : [];

  // =====================================================
  // UNIQUE PRODUCTS
  // =====================================================

  const productNames =
    useMemo(() => {

      return [
        ...new Set(
          safeProducts.map(
            (item) =>
              item.master_product
          )
        ),
      ];

    }, [safeProducts]);

  // =====================================================
  // ACTIVE PRODUCT
  // =====================================================

  const activeProduct =
    selectedProduct ||
    productNames[0] ||
    "";

  // =====================================================
  // CHART DATA
  // =====================================================

  const chartData =
    useMemo(() => {

      return safeProducts.filter(
        (item) =>
          item.master_product ===
          activeProduct
      );

    }, [
      safeProducts,
      activeProduct,
    ]);

  // =====================================================
  // EMPTY STATE
  // =====================================================

  if (
    safeProducts.length === 0
  ) {

    return (

      <div className="chart-container">

        <h2>
          Historical Price Trend
        </h2>

        <p>
          No historical data available
        </p>

      </div>

    );
  }

  // =====================================================
  // RENDER
  // =====================================================

  return (

    <div className="chart-container">

      <div className="section-header">

        <div>

          <h2>
            Historical Price Trend
          </h2>

          <p className="section-subtitle">

            Track platform-wise
            pricing movement over time

          </p>

        </div>

      </div>

      {/* SELECT */}

      <div
        style={{
          marginBottom: "25px",
        }}
      >

        <select
          className="filter-select"
          value={activeProduct}
          onChange={(e) =>
            setSelectedProduct(
              e.target.value
            )
          }
        >

          {productNames.map(
            (
              product,
              index
            ) => (

              <option
                key={index}
                value={product}
              >
                {product}
              </option>

            )
          )}

        </select>

      </div>

      {/* CHART */}

      <ResponsiveContainer
        width="100%"
        height={450}
      >

        <LineChart
          data={chartData}
        >

          <CartesianGrid
            strokeDasharray="3 3"
          />

          <XAxis
            dataKey="snapshot_date"
          />

          <YAxis />

          <Tooltip />

          <Legend />

          {/* F2B */}

          <Line
            type="monotone"
            dataKey="farm2bag_price"
            stroke="#16a34a"
            strokeWidth={3}
            name="F2B"
          />

          {/* BLINKIT */}

          <Line
            type="monotone"
            dataKey="blinkit_price"
            stroke="#f97316"
            strokeWidth={3}
            name="Blinkit"
          />

          {/* ZEPTO */}

          <Line
            type="monotone"
            dataKey="zepto_price"
            stroke="#7c3aed"
            strokeWidth={3}
            name="Zepto"
          />

          {/* BIGBASKET */}

          <Line
            type="monotone"
            dataKey="bigbasket_price"
            stroke="#ef4444"
            strokeWidth={3}
            name="BigBasket"
          />

        </LineChart>

      </ResponsiveContainer>

    </div>
  );
}

export default HistoricalTrendChart;